(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefits-slider"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if (window.__oracleAboutSliderBound) return;
    window.__oracleAboutSliderBound = true;

    function initAboutSlider(root) {
      if (!root || root.dataset.aboutSliderReady === 'true') return;
      root.dataset.aboutSliderReady = 'true';

      var slides = Array.prototype.slice.call(root.querySelectorAll('.about-slider__slide'));
      var total = slides.length;
      var interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
      var current = 0;
      var elapsed = 0;
      var lastTs = 0;
      var rafId = 0;
      var running = false;

      function setBarProgress(index, progress) {
        var slide = slides[index];
        if (!slide) return;
        var bar = slide.querySelector('.about-slider__progress-inner');
        if (!bar) return;
        bar.style.transform = 'scaleX(' + Math.max(0, Math.min(1, progress)) + ')';
      }

      function resetBars() {
        slides.forEach(function(_, index) {
          setBarProgress(index, 0);
        });
      }

      function setActive() {
        slides.forEach(function(slide, index) {
          slide.classList.toggle('is-active', index === current);
        });
        resetBars();
        setBarProgress(current, elapsed / interval);
      }

      function goTo(index) {
        if (!total) return;
        if (index < 0) index = total - 1;
        if (index >= total) index = 0;
        current = index;
        elapsed = 0;
        lastTs = 0;
        setActive();
      }

      function tick(ts) {
        if (!running) return;
        rafId = requestAnimationFrame(tick);

        if (document.hidden) {
          lastTs = 0;
          return;
        }

        if (!lastTs) {
          lastTs = ts;
          return;
        }

        var delta = ts - lastTs;
        lastTs = ts;

        if (delta > 200) return;

        elapsed += delta;

        if (elapsed >= interval) {
          goTo(current + 1);
          return;
        }

        setBarProgress(current, elapsed / interval);
      }

      function start() {
        if (total < 2 || running) return;
        running = true;
        lastTs = 0;
        rafId = requestAnimationFrame(tick);
      }

      function stop() {
        running = false;
        lastTs = 0;
        if (rafId) cancelAnimationFrame(rafId);
        rafId = 0;
      }

      slides.forEach(function(slide, index) {
        var title = slide.querySelector('.js-about-slider-title');
        if (!title) return;
        title.addEventListener('click', function() {
          goTo(index);
        });
      });

      setActive();
      start();

      root._aboutSliderStop = stop;
    }

    function initAllAboutSliders() {
      document.querySelectorAll('.about-slider').forEach(initAboutSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllAboutSliders);
    } else {
      initAllAboutSliders();
    }

    document.addEventListener('shopify:section:load', function(event) {
      var root = event.target.querySelector ? event.target.querySelector('.about-slider') : null;
      if (!root && event.target.classList && event.target.classList.contains('about-slider')) {
        root = event.target;
      }
      if (root) {
        delete root.dataset.aboutSliderReady;
        initAboutSlider(root);
      }
    });

    document.addEventListener('shopify:section:unload', function(event) {
      var root = event.target.querySelector ? event.target.querySelector('.about-slider') : null;
      if (!root && event.target.classList && event.target.classList.contains('about-slider')) {
        root = event.target;
      }
      if (!root) return;
      if (root._aboutSliderStop) root._aboutSliderStop();
      delete root.dataset.aboutSliderReady;
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
